import {
	jsonArrayProperty,
	jsonProperty,
	AnyType,
} from '@sumbricht/json-class-serializer'
import { assignCommonProperties } from '../util/data/assign-common-properties.js'
import type {
	ReportView,
	ReportViewSort,
	ReportViewFilter,
	ReportViewFilterValue,
	ReportViewSortDirection,
	ReportViewAggregation,
} from './report-view.js'
import type {
	ReportViewAggregationOperator,
	ReportViewFilterOperator,
} from '../consts.js'

export class ReportViewStaticFilter implements ReportViewFilter {
	@jsonProperty(String)
	property!: string
	@jsonProperty(String)
	operator!: ReportViewFilterOperator
	@jsonProperty(AnyType)
	values!: ReportViewFilterValue[]
}

export class ReportViewStaticSort implements ReportViewSort {
	@jsonProperty(String)
	property!: string
	@jsonProperty(String)
	direction!: ReportViewSortDirection
}

export class ReportViewStaticAggregation implements ReportViewAggregation {
	@jsonProperty(String)
	property!: string
	@jsonProperty(String)
	operator!: ReportViewAggregationOperator
	@jsonProperty(String)
	outputName?: string
}

export class ReportViewStatic implements ReportView {
	@jsonProperty(String)
	name!: string
	@jsonProperty(String)
	description!: string
	@jsonArrayProperty(ReportViewStaticFilter)
	filters: ReportViewFilter[] = []
	@jsonArrayProperty(ReportViewStaticSort)
	sorts: ReportViewSort[] = []
	@jsonArrayProperty(ReportViewStaticAggregation)
	aggregations: ReportViewAggregation[] = []
	@jsonArrayProperty(String)
	groupBy: string[] = []
	@jsonArrayProperty(String)
	select: string[] = []
	constructor(init?: Partial<ReportViewStatic>) {
		assignCommonProperties(this, init)
	}
}
